<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import { TimelineMax as Line, Power1 } from 'gsap'
import BaseButton from '@/components/base-button'

export default {

  name: 'ProjectDescriptionWidget',

  components: {
    BaseButton
  },

  props: {
    content: [Object]
  },

  data () {
    return {
      tl: null
    }
  },

  methods: {
    beforeAppear () {
      const tl = this.tl = new Line({ paused: true })
      const group = []

      if (this.$refs.type) group.push(this.$refs.type)
      if (this.$refs.year) group.push(this.$refs.year)
      if (this.$refs.client) group.push(this.$refs.client)
      if (this.$refs.button) group.push(this.$refs.button.$el)
      if (this.$refs.goal) group.push(this.$refs.goal)

      tl.staggerFrom(group, 1, {
        autoAlpha: 0,
        y: -20,
        ease: Power1.easeOut
      }, 0.1)
    },

    appear () {
      this.tl.play()
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.widget
  .widget__content
    .widget__row
      .widget__column.project-details

        .widget-item(v-if="content.entityType" ref="type")
          .widget-item__title {{ $t('project-type') }}:
          .widget-item__content {{ content.entityType }}

        .widget-item(v-if="content.year" ref="year")
          .widget-item__title {{ $t('project-year') }}:
          .widget-item__content {{ content.year }}

        .widget-item(v-if="content.client" ref="client")
          .widget-item__title {{ $t('project-client') }}:
          .widget-item__content {{ content.client }}

      .widget__column.widget__column--btn
        base-button.project-url(v-if="content.link && content.link.url", :url="content.link.url", :label="$t('launch-website')" ref="button" target='_blank')

    .widget__row(v-if="content.goal")
      .widget-item(ref="goal")
        .widget-item__title {{ $t('project-goals') }}:
        .widget-item__content {{ content.goal }}

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.widget
  padding-top 95px
  padding-bottom 90px
  display flex
  justify-content center

  +hd()
    padding 125px 0 60px

  +mobile()
    padding-top 60px
    padding-bottom 42px

  &__content
    position relative
    display flex
    flex-direction column
    max-width 1188px
    width 100%
    padding 0 90px

    +hd()
      max-width 1300px

    +mobile()
      padding 0 30px 50px

  &__row
    display flex

    +mobile()
      flex-direction column

    & + &
      margin-top 50px

      +mobile()
        margin-top 25px

  &__column
    flex 1 0 50%
    display flex

    +tablet()
      .button
        margin-left auto

    +mobile()
      flex-direction column

    &--btn
      +mobile()
        position absolute
        bottom 0
        left 30px

.widget-item
  display flex
  flex-direction column

  & + &
    +mobile()
      margin-top 20px

  .project-details &
    width 114px
    padding-right 18px

    +mobile()
      width 100%
      padding-right 0

  &__title
    padding-top 5px
    padding-bottom 30px
    font-weight 500
    font-size 12px
    line-height 14px
    color blue
    text-transform capitalize

    +mobile()
      padding-bottom 10px

  &__content
    font-size 14px
    line-height 22px

</style>



// WEBPACK FOOTER //
// project-description.vue?73937f6e